import React from "react";
import { useActiveSubjectTransform } from "../../../../../hooks/editor/useActiveSubjectTransform";
import {
  FlipResetIcon,
  FlipHorizontalIcon,
  FlipVerticalIcon,
} from "../../../../../icons";
import styles from "./Flip.module.css";

const Flip = () => {
  const { flipH, flipV, setFlipH, setFlipV, resetFlip } =
    useActiveSubjectTransform();

  return (
    <div className={styles.container}>
      <p className="subject-section-label">Flip</p>

      <div className={styles.buttonRow}>
        <button className={styles.segment} onClick={() => resetFlip()}>
          <FlipResetIcon className={styles.icon} />
          <span className={styles.label}>Reset</span>
        </button>

        <button
          className={`${styles.segment} ${flipH ? styles.active : ""}`}
          onClick={() => setFlipH(!flipH)}
        >
          <FlipHorizontalIcon className={styles.icon} />
          <span className={styles.label}>Flip H</span>
        </button>

        <button
          className={`${styles.segment} ${flipV ? styles.active : ""}`}
          onClick={() => setFlipV(!flipV)}
        >
          <FlipVerticalIcon className={styles.icon} />
          <span className={styles.label}>Flip V</span>
        </button>
      </div>
    </div>
  );
};

export default Flip;
